var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexibilityclean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.421,
    height: 87.419,
    viewBox: "0 0 87.421 87.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bd6a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05aae6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curved-arrow",
    d: "M53.452,44.709a23.312,23.312,0,0,0-46.623,0v20.4H3.915A2.913,2.913,0,0,0,1.49,69.638L13.146,87.122a2.915,2.915,0,0,0,4.849,0L29.651,69.638a2.913,2.913,0,0,0-2.424-4.531H24.312v-20.4a5.828,5.828,0,0,1,11.656,0,23.312,23.312,0,1,0,46.623,0v-20.4h2.914A2.913,2.913,0,0,0,87.93,19.78L76.274,2.3a2.915,2.915,0,0,0-4.849,0L59.769,19.78a2.913,2.913,0,0,0,2.424,4.531h2.914v20.4a5.828,5.828,0,1,1-11.656,0Zm-5.828,0a11.656,11.656,0,1,0,23.312,0V21.4a2.915,2.915,0,0,0-2.914-2.914H67.64l6.21-9.316,6.21,9.316h-.382A2.915,2.915,0,0,0,76.764,21.4V44.709a17.484,17.484,0,1,1-34.968,0,11.656,11.656,0,0,0-23.312,0V68.021A2.915,2.915,0,0,0,21.4,70.935h.382l-6.21,9.316-6.21-9.316h.382a2.915,2.915,0,0,0,2.914-2.914V44.709a17.484,17.484,0,0,1,34.968,0Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibilityclean);
export default __webpack_public_path__ + "static/media/flexibilityclean.af4b742a1051c4f11104ffd8ed23f0c4.svg";
export { ForwardRef as ReactComponent };